<!-- 首页跳转 校友卡 页面 -->
<template>
  <AlumniCardComponents></AlumniCardComponents>
</template>
<script>
import AlumniCardComponents from "@/components/alumniCard/AlumniCardComponents.vue";
export default {
  components: {
    AlumniCardComponents,
  },
  data() {
    return {
      openid: this.$route.query.openid,
      cardInfo: [],
      photoUrl: "",
      token: "",
      codeImg: "",
      timer: "",
      percentage: 100,
      percentageTimer: "",
      isRealNam: "",
      isReal: "",
      isNewNvliangDialog: false,
    };
  },
  created() {
    // this.getAlumnusCard();
    // this.getData();
    // this.currentTime();
    // this.countdownTime();
    // this.isRealNam = this.$route.query.realNam;
    /**
     * 实名认证你无关
     */
    // this.realName();
  },

  methods: {
    nvliangDialog() {
      this.isNewNvliangDialog = true;
    },
    closeDialog() {
      this.isNewNvliangDialog = false;
    },
    // 实名认证你无关
    async realName() {
      if (this.$route.query.status == 1) {
        this.isReal = this.$route.query.status;
        // 存入实名认证状态
        const res = await this.$http({
          // url: `/realNameAuthentication/realNameStatus?userId=${data.userId}&realNameAuthentication=${data.realNameAuthentication}`,
          url: `/realNameAuthentication/realNameStatus?userId=${localStorage.getItem(
            "user_id"
          )}&realNameAuthentication=1`,
          method: "POST",
          // data:data,
        });
        if (res.data.code == 200) {
          localStorage.setItem("realStatus", this.isReal);
          this.$toast("实名认证成功");
        } else {
          this.$toast("实名认证失败");
        }
      }
    },
    // // 校友卡获取
    // async getAlumnusCard() {
    //   const result = await this.$http.get("/my/getBasic", {
    //     // params: { userId: localStorage.getItem("user_id") },
    //     params: { userId: "43995354" },
    //   });
    //   this.cardInfo = result.data;
    //   console.log("校友卡获取", this.cardInfo);
    //   // // TODO
    //   // this.getCodeImg();
    // },
    async getData() {
      // const res = await this.$http.get(`/xjcard/recompletion?openid=${window.localStorage.getItem("openid")}`)
      const res = await this.$http.get(
        `/xjcard/recompletion?openid=${this.openid}`
      );
      if (res.data != null) {
        this.photoUrl = res.data.url;
      }
    },
    async getCodeImg() {
      const res = await this.$http.get(
        `/xjcard/QrcodeByalumnsId?alumnsId=${this.cardInfo.alumnusId}`,
        {}
      );
      this.codeImg = res.data.data.qrcode;
      this.percentage = 100;
    },
    currentTime() {
      this.timer = setInterval(this.getCodeImg, 10000);
    },
    countdown() {
      if (this.percentage <= 100 && this.percentage > 0) {
        this.percentage = this.percentage - 10;
      } else if (this.percentage < 1) {
        this.percentage = 100;
      }
    },
    countdownTime() {
      this.percentageTimer = setInterval(this.countdown, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/alumniCard/AlumniCard.vue